const Utill  = require("../utillity/utill");
const Rwd    = require("../utillity/responsive");

const Header = require("../dom/header");
const Pagetop= require('../dom/pagetop');

const ScrSec = require('../animation/section_scroll');
const Slider = require('../animation/slider');
const Home   = require('../animation/home');

const Pjx    = require("./pjx");
const Click  = require("./click");

const Loader = require('../loader');

const Calc   = require("../utillity/calculate");

const MAP = require('../animation/map');


module.exports.Bind = function(pjax_active) {
	// pjax_active: true or false

	// PJAX遷移かどうかで判断
	if( pjax_active ) {
		Pjx.SetSignature();		// 絶対に一番初めに実行
		Pjx.SetH1();
		Header.FadeIn();
		if( Utill.IsPage('home') ){

			Slider.Init();
			Slider.Start();
			Header.ControleLogo(0);
		}
		if ( Utill.IsOriginAnime() ) {

		}else {
			ScrSec.Init();
			
		}

	}else {
		Pjx.Init();
		Click.Bind();
		
		if( Utill.IsPage('home') ){

			Slider.Init();
			if( Utill.IsOriginAnime() ){
				Loader.Init();
			}else {
				ScrSec.Init();
			}
		}else {
			$('#loader').fadeOut(300, function(){$('#loader').remove()});
			Header.FadeIn();	
			$.scrollify.disable();
			$('#mainvisual').addClass('is_anim');
		}
	}


	// TOPか下層かで判断
	if( Utill.IsPage('home') ){
		Home.SectionControllerInit();
	}else {
		Slider.Break();
	}

	// scrollifyが無効かどうかで判断
	if ( Utill.IsOriginAnime() ) {
		ScrSec.SetSize();
		ScrSec.InitPagination();
		ScrSec.slugInit();
		$.scrollify.disable();
		$('body').addClass('is_scrollify_false');
	}else {
		$.scrollify.enable();
		$('body').addClass('is_scrollify_true');
		$('[data-section_bg]').remove();
		Header.FadeIn();
		Slider.Start();
	}


	// skin系
	
	MAP.Init();

	Utill.LazyLoad_img();
	

	Header.SetSkin();
	Pagetop.Controll();
	Pagetop.ControllVisible(0);

	if( pjax_active ) {
		ScrSec.ToggleEnable();
	}




	if( pjax_active ) {
		var _gaq = _gaq || [];
		_gaq.push(['_setAccount', 'UA-19299525-1']);
		_gaq.push(['_trackPageview']);
	}else {
		var _gaq = _gaq || [];
		_gaq.push(['_setAccount', 'UA-19299525-1']);
		_gaq.push(['_trackPageview']);
		(function() {
		var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
		ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
		var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
		})();
		
	}

	

};


// WEBPACK FOOTER //
// ./html/_src/js_wb/events/ready.js